import { CasesActionTypes } from 'app/modules/casesOld/models';
import { DetectionModelsActionTypes } from 'app/modules/detectionModels/models';
import { EntitiesActionTypes } from 'app/modules/entitiesOld/models';
import { GoAMLActionTypes } from 'app/modules/goAML/models';
import { WorkflowActionTypes } from 'app/modules/workflowButtonConfig/models';

export const isFourOhFourRoute = (action: string) =>
  new Set([
    CasesActionTypes.RETRIEVE_CASE,
    GoAMLActionTypes.RETRIEVE_GOAML_FILING,
    WorkflowActionTypes.RETRIEVE_WORKFLOW,
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODEL_VALIDATION,
    EntitiesActionTypes.RETRIEVE_ENTITY,
    `investigationChecklist/RETRIEVE_INVESTIGATION_CHECKLIST`,
    `agents/GET_AGENT_DETAILS`,
    'fincenSarNew/RETRIEVE_SAR',
  ]).has(action);
